import moment from 'moment';
export var regex = {
    mobileRegExp: /^(\+\d{1,3}[- ]?)?\d{10}$/,
    emailRegExp: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    contractIdRegExp: /^[a-zA-Z0-9-]{0,15}$/,
};
export var emailValidation = function (email) {
    if (!email || typeof email !== 'string') {
        return 'Please Enter Email';
    }
    else if (!regex.emailRegExp.test(email)) {
        return 'Please Enter a Valid Email';
    }
    return '';
};
export var contractIdValidation = function (contractId) {
    if (!contractId || typeof contractId !== 'string') {
        return 'Please Enter Contract Id';
    }
    if (!regex.contractIdRegExp.test(contractId)) {
        return 'Contract Id must be alphanumeric, up to 15 characters';
    }
    return '';
};
export var NAME_MAX_LENGTH = 16;
export var NAME_MAX_SPACES = 3;
export var NAME_ALPHANUMERIC_PATTERN = /^[A-Za-z0-9 ]*$/;
export var firstNameOrLastNameValidation = function (value, fieldLabel) {
    if (!value || typeof value !== 'string') {
        return "Please Enter ".concat(fieldLabel);
    }
    var trimmed = value.trim();
    if (trimmed === '') {
        return "Please Enter ".concat(fieldLabel);
    }
    if (trimmed.length > NAME_MAX_LENGTH) {
        return "".concat(fieldLabel, " cannot exceed ").concat(NAME_MAX_LENGTH, " characters");
    }
    if (!NAME_ALPHANUMERIC_PATTERN.test(trimmed)) {
        return "".concat(fieldLabel, " can only contain letters, numbers, and spaces");
    }
    if (/\s{2,}/.test(trimmed)) {
        return "".concat(fieldLabel, " cannot contain consecutive spaces");
    }
    var spaceCount = (trimmed.match(/ /g) || []).length;
    if (spaceCount > NAME_MAX_SPACES) {
        return "".concat(fieldLabel, " can contain at most ").concat(NAME_MAX_SPACES, " spaces");
    }
    if (/^\d+$/.test(trimmed.replace(/\s+/g, ''))) {
        return "".concat(fieldLabel, " cannot be all numbers");
    }
    return '';
};
export var sanitizeNameInput = function (value) {
    var alphanumeric = value.replace(/[^A-Za-z0-9 ]/g, '');
    var withoutConsecutiveSpaces = alphanumeric.replace(/\s{2,}/g, ' ');
    return withoutConsecutiveSpaces.slice(0, NAME_MAX_LENGTH);
};
export var ssnNumberValidation = function (ssnNumber) {
    if (!ssnNumber || typeof ssnNumber !== 'string') {
        return 'Please Enter SSN Number';
    }
    var trimmed = ssnNumber.trim();
    if (trimmed === '') {
        return 'Please Enter SSN Number';
    }
    var digitsOnly = trimmed.replace(/\D/g, '');
    if (digitsOnly.length !== 9) {
        return 'SSN must be 9 digits in format (e.g., 123-45-6789)';
    }
    var areaNumber = digitsOnly.substring(0, 3);
    var groupNumber = digitsOnly.substring(3, 5);
    var serialNumber = digitsOnly.substring(5, 9);
    if (areaNumber === '000' || areaNumber === '666') {
        return 'Invalid SSN: First group cannot be 000 or 666';
    }
    if (groupNumber === '00') {
        return 'Invalid SSN: Second group cannot be 00';
    }
    if (serialNumber === '0000') {
        return 'Invalid SSN: Third group cannot be 0000';
    }
    return '';
};
export var formatSSNInput = function (value) {
    var digitsOnly = value.replace(/\D/g, '');
    var limitedDigits = digitsOnly.slice(0, 9);
    if (limitedDigits.length <= 3) {
        return limitedDigits;
    }
    else if (limitedDigits.length <= 5) {
        return "".concat(limitedDigits.slice(0, 3), "-").concat(limitedDigits.slice(3));
    }
    return "".concat(limitedDigits.slice(0, 3), "-").concat(limitedDigits.slice(3, 5), "-").concat(limitedDigits.slice(5));
};
export var federalTaxIdValidation = function (fedTaxId) {
    if (!fedTaxId || typeof fedTaxId !== 'string') {
        return 'Please Enter Federal Tax Number';
    }
    var trimmed = fedTaxId.trim();
    if (trimmed === '') {
        return 'Please Enter Federal Tax Number';
    }
    var digitsOnly = trimmed.replace(/\D/g, '');
    if (digitsOnly.length !== 9) {
        return 'Fed Tax Number must be 9 digits (e.g., 123456789)';
    }
    return '';
};
export var formatFederalTaxIdInput = function (value) {
    var digitsOnly = value.replace(/\D/g, '');
    var limitedDigits = digitsOnly.slice(0, 9);
    if (limitedDigits.length <= 2) {
        return limitedDigits;
    }
    return "".concat(limitedDigits.slice(0, 2), "-").concat(limitedDigits.slice(2));
};
export var sinNumberValidation = function (sinNumber) {
    if (!sinNumber || typeof sinNumber !== 'string') {
        return 'Please Enter SIN Number';
    }
    var trimmed = sinNumber.trim();
    if (trimmed === '') {
        return 'Please Enter SIN Number';
    }
    var digitsOnly = trimmed.replace(/\D/g, '');
    if (digitsOnly.length !== 9) {
        return 'SIN must be 9 digits';
    }
    return '';
};
export var formatSINInput = function (value) {
    var digitsOnly = value.replace(/\D/g, '');
    return digitsOnly.slice(0, 9);
};
export var businessNumberValidation = function (businessNumber) {
    if (!businessNumber || typeof businessNumber !== 'string') {
        return 'Please Enter Business Number';
    }
    var trimmed = businessNumber.trim();
    if (trimmed === '') {
        return 'Please Enter Business Number';
    }
    if (trimmed.length < 9 || trimmed.length > 15 || !/^\d{9}/.test(trimmed)) {
        return 'Business number must be 9-15 characters (e.g., 123456789RT0001)';
    }
    return '';
};
export var formatTaxIdInput = function (value) {
    return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
};
export var formatBusinessNumberInput = function (value) {
    var cleaned = value.replace(/-/g, '').toUpperCase();
    return cleaned.slice(0, 15);
};
export var postCodeValidation = function (postCode) {
    if (!postCode || typeof postCode !== 'string') {
        return 'Please Enter Post Code';
    }
    var trimmed = postCode.trim();
    if (trimmed === '') {
        return 'Please Enter Post Code';
    }
    if (!/^[a-zA-Z0-9]+(?:[\s-][a-zA-Z0-9]+)*$/.test(trimmed)) {
        return 'Please Enter a Valid Postal Code';
    }
    return '';
};
export var phoneNumberValidation = function (phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== 'string') {
        return 'Please Enter Phone Number';
    }
    var phoneDigits = phoneNumber.replace(/[\s\-()]/g, '');
    if (!regex.mobileRegExp.test(phoneDigits)) {
        return 'Please Enter a Valid Phone Number';
    }
    return '';
};
export var DOB_MIN_AGE_YEARS = 18;
export var DOB_MAX_AGE_YEARS = 120;
export var dateOfBirthValidation = function (dateOfBirth) {
    if (!dateOfBirth || typeof dateOfBirth !== 'string') {
        return 'Date of birth is required.';
    }
    var parsed = moment(dateOfBirth);
    if (!parsed.isValid()) {
        return 'Please enter a valid date.';
    }
    var minDate = moment().subtract(DOB_MAX_AGE_YEARS, 'years').startOf('day');
    var maxDate = moment().subtract(DOB_MIN_AGE_YEARS, 'years').endOf('day');
    if (parsed.isBefore(minDate) || parsed.isAfter(maxDate)) {
        return "Date of birth must indicate an age between ".concat(DOB_MIN_AGE_YEARS, " and ").concat(DOB_MAX_AGE_YEARS, " years.");
    }
    return '';
};
var getDobRangeBounds = function () { return ({
    minDate: moment().subtract(DOB_MAX_AGE_YEARS, 'years').startOf('day'),
    maxDate: moment().subtract(DOB_MIN_AGE_YEARS, 'years').startOf('day'),
}); };
export var isDobWithinAllowedRange = function (dateOfBirth) {
    if (!dateOfBirth || typeof dateOfBirth !== 'string')
        return false;
    var parsed = moment(dateOfBirth);
    if (!parsed.isValid())
        return false;
    var _a = getDobRangeBounds(), minDate = _a.minDate, maxDate = _a.maxDate;
    var start = parsed.clone().startOf('day');
    return !start.isBefore(minDate) && !start.isAfter(maxDate);
};
export var dateOfBirthRangeValidation = function (dateOfBirth) {
    if (!dateOfBirth || typeof dateOfBirth !== 'string') {
        return 'Date of birth is required.';
    }
    var parsed = moment(dateOfBirth);
    if (!parsed.isValid()) {
        return 'Please enter a valid date.';
    }
    var _a = getDobRangeBounds(), minDate = _a.minDate, maxDate = _a.maxDate;
    var start = parsed.clone().startOf('day');
    if (start.isBefore(minDate)) {
        return "Date of birth cannot indicate an age over ".concat(DOB_MAX_AGE_YEARS, " years.");
    }
    if (start.isAfter(maxDate)) {
        return "You must be at least ".concat(DOB_MIN_AGE_YEARS, " years old to register.");
    }
    return '';
};
